import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css, keyframes } from 'styled-components';
export function LoadingIndicator({ loading = false }) {
    return _jsx(LoadingIndicatorRoot, { "$visible": loading });
}
const slide = keyframes `
    0% {
        transform: translateX(-100%) translateZ(0);
    }

    45% {
        transform: translateX(0%) translateZ(0);
    }

    55% {
        transform: translateX(0%) translateZ(0);
    }

    100% {
        transform: translateX(100%) translateZ(0);
    }
`;
const LoadingIndicatorRoot = styled.div `
    height: 2px;
    left: 0;
    opacity: 0;
    overflow: hidden;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 250ms opacity;
    width: 100%;

    &::before {
        animation: 4s infinite ${slide};
        animation-play-state: paused;
        background: #ffffff;
        box-shadow: 0 2px 2px 25px #ffffff;
        content: "";
        height: 100%;
        border-radius: 2px;
        position: absolute;
        width: 100%;
    }

    ${({ $visible }) => $visible &&
    css `
            opacity: 1;

            &::before {
                animation-play-state: running;
            }
        `}
`;
